import { WEBSHARE_IP4_ADDRESS } from "@/config/constants";

interface IProps {
  protocol: string;
  proxyUserName: string;
  password: string;
  domainName: string;
  authenticationMethod: string;
  port?: string;
}

export const bash = ({
  protocol,
  proxyUserName,
  password,
  domainName,
  authenticationMethod,
  port,
}: IProps) =>
  authenticationMethod === "ip"
    ? `curl --proxy "${protocol}://${domainName}:${port}/" https://${WEBSHARE_IP4_ADDRESS}/`
    : `curl --proxy "${protocol}://${proxyUserName}:${password}@${domainName}:${port}/" https://${WEBSHARE_IP4_ADDRESS}/`;

export const python = ({
  protocol,
  proxyUserName,
  password,
  domainName,
  authenticationMethod,
  port,
}: IProps) => {
  const url =
    authenticationMethod === "ip"
      ? `${protocol}://${domainName}:${port}/`
      : `${protocol}://${proxyUserName}:${password}@${domainName}:${port}/`;
  return `import requests
requests.get(
    "https://${WEBSHARE_IP4_ADDRESS}/",
    proxies={
        "http": "${url}",
        "https": "${url}"
    }
).text
`;
};

export const java = ({
  proxyUserName,
  password,
  domainName,
  authenticationMethod,
  port,
}: IProps) => `import org.apache.http.HttpHost;
import org.apache.http.client.fluent.*;

public class Example {
    public static void main(String[] args) throws Exception {
        HttpHost proxy = new HttpHost("${domainName}", "${port}");
        String res = Executor.newInstance() ${
          authenticationMethod === "ip"
            ? ""
            : `
            .auth(proxy, "${proxyUserName}", "${password}")`
        }
            .execute(Request.Get("http://${WEBSHARE_IP4_ADDRESS}/").viaProxy(proxy))
            .returnContent().asString();
        System.out.println(res);
    }
}
`;

export const cSharp = ({
  proxyUserName,
  password,
  domainName,
  authenticationMethod,
  port,
}: IProps) => `using System;
using System.Net;

class Example
{
    static void Main()
    {
        var client = new WebClient();
        client.Proxy = new WebProxy("${domainName}:${port}");
        ${
          authenticationMethod === "ip"
            ? ""
            : `
          client.Proxy.Credentials =
          new NetworkCredential("${proxyUserName}", "${password}");`
        }
        Console.WriteLine(client.DownloadString("http://${WEBSHARE_IP4_ADDRESS}/"));
    }
}`;

export const nodejs = ({
  protocol,
  proxyUserName,
  password,
  domainName,
  authenticationMethod,
  port,
}: IProps) => {
  const proxyUrl =
    authenticationMethod === "ip"
      ? `${protocol}://${domainName}:${port}`
      : `${protocol}://${proxyUserName}:${password}@${domainName}:${port}`;
  return `require('request-promise')({
  url: 'http://${WEBSHARE_IP4_ADDRESS}/',
  proxy: '${proxyUrl}'
}).then(function(data){
  console.log(data); 
}, function(err){ 
  console.error(err); 
});`;
};

export const php = ({
  protocol,
  proxyUserName,
  password,
  domainName,
  authenticationMethod,
  port,
}: IProps) => `<?php
$curl = curl_init('http://${WEBSHARE_IP4_ADDRESS}/');
curl_setopt($curl, CURLOPT_PROXY, '${protocol}://${domainName}:${port}');
${
  authenticationMethod === "ip"
    ? ""
    : `curl_setopt($curl, CURLOPT_PROXYUSERPWD, '${proxyUserName}:${password}');`
}
curl_exec($curl);
?>`;

export const ruby = ({
  proxyUserName,
  password,
  domainName,
  authenticationMethod,
  port,
}: IProps) => `#!/usr/bin/ruby

require 'uri'
require 'net/http'
uri = URI.parse('http://${WEBSHARE_IP4_ADDRESS}/')
proxy = Net::HTTP::Proxy(
  '${domainName}',
  ${port}${authenticationMethod === "ip" ? "" : `, '${proxyUserName}', '${password}'`}
)

req = Net::HTTP::Get.new(uri.path)

result = proxy.start(uri.host,uri.port) do |http|
    http.request(req)
end

puts result.body`;

export const vb = ({
  proxyUserName,
  password,
  domainName,
  authenticationMethod,
  port,
}: IProps) => `Imports System.Net

Module Example
    Sub Main()
        Dim Client As New WebClient
        Client.Proxy = New WebProxy("http://${domainName}:${port}")
       ${
         authenticationMethod === "ip"
           ? ""
           : ` Client.Proxy.Credentials = _
       New NetworkCredential("${proxyUserName}", "${password}")`
       }
        Console.WriteLine(Client.DownloadString("http://${WEBSHARE_IP4_ADDRESS}/"))
    End Sub
End Module`;
